import { FC } from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import Conceive from "~/images/logos/conceive_green.png";
import { usePartner } from "~/OnboardingApp/hooks";
import { welcomePhase } from "./config/constants";
import { useNav } from "./useNav";

export const Phase: FC = () => {
  const { phase } = useNav();
  const { isPartner, partnerMeta } = usePartner();
  const partnerLogoSrc = isPartner ? partnerMeta.logoUrl : undefined;

  if (isPartner && phase === welcomePhase) {
    return (
      <Flex align="center" gap={{ base: 3, md: 4 }} justify="center">
        {partnerLogoSrc && (
          <>
            <Image alt={`${partnerMeta.name} logo`} maxH={{ base: "1.75rem", md: "2.25rem" }} src={partnerLogoSrc} />
            <Box bg="th.signatureGreen" h={{ base: "1.75rem", md: "2.25rem" }} w="2px" />
          </>
        )}
        <Image alt="Conceive logo" maxH={{ base: "1.25rem", md: "1.75rem" }} src={Conceive} />
      </Flex>
    );
  }

  return (
    <Text textTransform="uppercase" variant="th-t2">
      {phase}
    </Text>
  );
};
